import React, { Component } from "react";
import PropTypes from "prop-types";
import Helpers from "../Utils/Helpers";
import Registry from "../Utils/Registry";


export default class TYCheckBox extends Component{
	constructor(props){
		super(props);
		this.state = {
			checked: props.checked
		};
	}

	componentDidUpdate(prevProps){
		if(this.props.checked !== prevProps.checked)
			this.setState({checked: this.props.checked});
	}

	toggle = () => {
		this.setState({checked: !this.state.checked}, () => {
			this.props.onToggle(this.state.checked);
		})
	};

	render(){
		return (
			<div className={"ty-checkbox " + (this.state.checked ? "checked" : "") + " " + this.props.className} onClick={this.toggle}>
				{
					this.state.checked ?
						<i className="icon icon-check ty-bold" />
						: null
				}
			</div>
		);
	}
}

TYCheckBox.propTypes = {
	className: PropTypes.string,
	checked: PropTypes.bool,
	onToggle: PropTypes.func
};

TYCheckBox.defaultProps = {
	className: "",
	checked: false,
	onToggle: value => {}
};



// WEBPACK FOOTER //
// ./src/components/TYCheckBox.js